import CouponItem from "../customer/my-coupon/CouponItem";
import { useState } from "react";
import { useListCouponCms } from "@api/coupon/coupon";
import { COUPON_PAGE_SIZE, COUPON_DEFAULT_PAGE } from "@const/products.const";
import { userSelector } from "@stores/slices/userSlice";
import { useSelector } from "react-redux";
import { SkeletonCoupon } from "@components/atoms/skeleton/ui-coupon";

const CouponCms = () => {
  const user = useSelector(userSelector);
  const customerId = user.user?.id.toString();
  const customerIdNum = user.user?.id;
  const [currentPage, setCurrentPage] = useState<number>(COUPON_DEFAULT_PAGE);
  const {
    data: dataCoupon,
    isLoading: isLoadingCoupon,
    error: errorcoupon,
    mutate: couponMutate,
  } = useListCouponCms({
    customerId: customerId !== undefined ? customerId : undefined,
    productDisplayConfig: {
      pageSize: COUPON_PAGE_SIZE,
      currentPage: currentPage,
    },
  });

  return (
    <>
      <div className="container-fluid mt-2">
        <section className="product-section px-3 py-3 bg-white rounded-2">
          <div>
            <h4 className="title-cms p-3 text-red">คูปองส่วนลด</h4>
          </div>
          {isLoadingCoupon ? (
            <div className="row">
              <SkeletonCoupon count={6} />
            </div>
          ) : (
            <CouponItem
              couponList={dataCoupon}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              customerId={customerIdNum}
              couponMutate={couponMutate}
            />
          )}
        </section>
      </div>
    </>
  );
};

export default CouponCms;
